export default __webpack_public_path__ + "static/media/us-tx.2dd726dc.svg";